import { Check } from '@untitled-ui/icons-react';
import { twMerge } from 'tailwind-merge';

export type StepIndicatorProps = {
  step: number;
  isCurrent: boolean;
  isCompleted: boolean;
  label: string;
  onClick?: () => void;
  className?: string;
};

export function StepIndicator(props: StepIndicatorProps) {
  return (
    <div
      className={twMerge(
        'flex items-center justify-between gap-1 rounded-md bg-transparent px-3 py-2 hover:bg-branding-gray',
        props.className
      )}
      onClick={props.onClick}
    >
      <div
        className={twMerge(
          'flex size-5 items-center justify-center rounded-full bg-branding-accent-50 text-center',
          props.isCurrent ? 'bg-branding-accent' : '',
          props.isCompleted ? 'bg-green-400 text-white' : ''
        )}
      >
        {props.isCompleted ? (
          <Check width={12} height={12} />
        ) : (
          <span className={twMerge('font-body-2-m', props.isCurrent ? 'text-white' : 'text-black')}>
            {props.step}
          </span>
        )}
      </div>
      <p
        className={`font-body-2-m ${props.isCurrent || props.isCompleted ? 'text-black' : 'text-dark-gray'}`}
      >
        {props.label}
      </p>
    </div>
  );
}
